import { OverflowFadeText } from '@/components/layout/OverflowFadeText';
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbSeparator,
} from '@/components/ui/breadcrumb';
import type { InspectorBreadcrumbItem } from '@/components/ui/inspector/types';
import { BREADCRUMB_LEAF_CLASS, BREADCRUMB_ROOT_CLASS } from '@/lib/ui-tokens';
import { cn } from '@/lib/utils';

export function InspectorBreadcrumb({
  breadcrumbs,
  fallbackTitle,
}: {
  breadcrumbs?: InspectorBreadcrumbItem[];
  fallbackTitle: string;
}) {
  const root = breadcrumbs?.[0];
  const leaf = breadcrumbs?.[breadcrumbs.length - 1]?.label ?? fallbackTitle;

  if (!root) {
    return (
      <h2 className={cn(BREADCRUMB_LEAF_CLASS, 'min-w-0 flex-1 text-sm font-medium')}>
        <OverflowFadeText className="block min-w-0" title={fallbackTitle}>
          {fallbackTitle}
        </OverflowFadeText>
      </h2>
    );
  }

  const rootNode = root.href ? (
    <BreadcrumbLink href={root.href} className={cn(BREADCRUMB_ROOT_CLASS, 'shrink-0')}>
      {root.label}
    </BreadcrumbLink>
  ) : (
    <span className={cn(BREADCRUMB_ROOT_CLASS, 'shrink-0')}>{root.label}</span>
  );

  return (
    <Breadcrumb className="min-w-0 flex-1">
      <BreadcrumbList className="min-w-0 flex-nowrap break-normal gap-1.5 text-sm font-medium tracking-tight">
        <BreadcrumbItem className="hidden shrink-0 sm:inline-flex">{rootNode}</BreadcrumbItem>
        <BreadcrumbSeparator className="hidden text-muted-foreground/40 sm:inline-flex" />
        <BreadcrumbItem className={cn(BREADCRUMB_LEAF_CLASS, 'min-w-0 flex-1 text-sm font-medium')}>
          <OverflowFadeText className="block min-w-0" title={leaf}>
            {leaf}
          </OverflowFadeText>
        </BreadcrumbItem>
      </BreadcrumbList>
    </Breadcrumb>
  );
}
